import type { TaskStatus } from './generated/gql-enums';

export const TASK_STATUS_DONE = 'done' satisfies TaskStatus;
export const TASK_STATUS_IN_PROGRESS = 'in_progress' satisfies TaskStatus;
